import React, { Component, Fragment } from "react";
import Modal from "../../Modal";
import "../../Styles/Pages/packagelist.scss";
import withAppData from "../../HOC/withAppData";
import { asset_url, oran_key } from "../../app-config";
import dayjs from "dayjs";
import Button from "../../Resources/Forms/Button";
import {
	PrintIcon,
	LeadStageChangeIcon,
	SkuIcon,
} from "../../Resources/Icons/Collections";
import {
	_printElement,
	_capitalizeText,
	_formatCurrency,
	_cloneObject,
} from "../../Utils/helpers";
import { GET } from "../../Utils/api";
import Loading from "../../Loaders/Loading";
import axios from "axios";
import OrderPrintInvoice from "../WareHouse/OrderPrintInvoice";
import "../../Styles/Pages/orderposprint.scss";

class ShipmentPrintList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			packageDate: dayjs().format("MMM D, YYYY"),
			packageTime: dayjs().format("h:mm a"),
			printIconColor: "#015fd1",
			orders: [],
			items: [],
			maxHeight: "450px",
			showPreview: true,
			agents: [],
			selectedAgent: "",
			includeAllOrders: false,
			selectedOrders: null,
			arrangedOrders: null,
			order: {},
			allOrders: [],
			viewingList: false,
			uniquePackages: [],
			altIconColor: "#015fd1",
			isEditing: false,
			optimizingRoute: false,
			optimized: false,
			showMap: false,
			distance: 0,
			packageListStatus: false,
			SOnumber: "",
			WaybillNumber: "",
			IsGenerated: "",
			isPackageManager:
				this.props.context.role.toLowerCase().includes("packaging manager") &&
				this.props.context.isMultiProBusiness,
			isDriver: ["reseller biker", "reseller van driver"].includes(
				this.props.context.role.toLowerCase(),
			),
			showLoader: true,
			shipmentOrders: [],
			unpackagedOrders: [],
			loadingUnpackagedUserOrders: false,
			totalOrderValue: 0,
			shipmentOrderData: {},
			allOrderDetails: [],
			showPrintOrders: false,
		};
		this.containerRef = React.createRef();
	}

	componentDidMount() {
		this.getShipmentInvoicesData();
	}

	getShipmentInvoicesData = async () => {
		let reqUrl = `orderManagement/getShipmentInvoicesData?shipmentId=${this.props.packageId}`;
		let header = _cloneObject(
			this.props.jsonHeader
				? this.props.jsonHeader
				: this.props.context.jsonHeader,
		);
		const result = await GET(reqUrl, header);
		if (
			result.shipmentDetails &&
			result.shipmentDetails[0].shipmentOrders &&
			result.shipmentDetails[0].shipmentOrders.length
		) {
			this.setState({
				shipmentOrderData: result.shipmentDetails[0],
			});
			await this.getAllOrdersData();
		} else {
			this.props.close();
		}
	};

	getPackageListStatus = async () => {
		this.setState({ gettingStatus: true });
		let headers = _cloneObject(
			this.props.jsonHeader
				? this.props.jsonHeader
				: this.props.context.jsonHeader,
		);
		headers.headers["APIKEY"] = oran_key;
		const result = await GET(
			`Dataupdate/GetDispatchStatus?ShipmentID=${
				this.props.packageId
			}&orderId=${
				this.state.shipmentOrderData &&
				this.state.shipmentOrderData.shipmentOrders &&
				this.state.shipmentOrderData.shipmentOrders.length
					? this.state.shipmentOrderData.shipmentOrders[0].orderId
					: ""
			}`,
			headers,
		);

		if (result && result.length) {
			debugger;
			if (result[0].IsGenerated.toLowerCase() === "generated") {
				this.setState(
					{
						packageListStatus: true,
						IsGenerated: result[0].IsGenerated,
						SOnumber: result[0].SoNumber,
						WaybillNumber: result[0].WayBillNo,
						dispatchApproved:
							result[0].DispatchStatus &&
							result[0].DispatchStatus.toLowerCase() === "approved",
					},
					() => {
						this.setState({
							shipmentGenerationMessage: this.state.dispatchApproved
								? ""
								: "Pending Waybill Approval",
						});
						this.props.context.showAlert(
							!this.state.dispatchApproved
								? "Pending waybill approval"
								: "Waybill " + _capitalizeText(result[0].DispatchStatus),
							"success",
							"Generated successfully",
						);
					},
				);
			} else {
				this.props.context.showAlert(
					result[0].IsGenerated === "SHIPMENT GENERATION FAILED"
						? "Orders in this shipment list will be reassigned to the warehouse"
						: "",
					"error",
					_capitalizeText(result[0].IsGenerated),
				);
				this.setState({
					shipmentGenerationMessage: _capitalizeText(result[0].Remarks),
				});
				this.setState({
					IsGenerated: result[0].IsGenerated.toLowerCase(),
				});
			}
		} else if (result.ISGENERATED === "PENDING FOR GENERATION") {
			this.setState({
				packageListStatus: true,
				IsGenerated: result.ISGENERATED,
				shipmentGenerationMessage: "",
			});
		} else {
			this.props.context.showAlert(
				"An error occured. Please try again",
				"error",
			);
			this.setState({ shipmentGenerationMessage: "" });
		}
		this.setState(
			{ gettingStatus: false },
			() =>
				this.containerRef.current && this.containerRef.current.scrollIntoView(),
		);

		this.updateShipments();
	};
	updateShipments = () => {
		if (this.props.getShipments) {
			this.props.getShipments();
		}
	};

	getAllOrdersData = async () => {
		this.requestSource = axios.CancelToken.source();
		let header = _cloneObject(
			this.props.jsonHeader
				? this.props.jsonHeader
				: this.props.context.jsonHeader,
		);
		let ordersDetails = [];
		let respCopy = {};
		this.state.shipmentOrderData &&
			this.state.shipmentOrderData.shipmentOrders &&
			(await Promise.all(
				this.state.shipmentOrderData.shipmentOrders.map(async shipment => {
					const resp = await GET(
						`Store/GetOnlineOrders_Retail_details?Orderid=${shipment.orderId}`,
						header,
						this.requestSource.token,
					);
					if (!resp.error) {
						respCopy = resp;
						respCopy.alternatePhone1 = shipment.alternatePhone1;
						respCopy.alternatePhone2 = shipment.alternatePhone2;
						respCopy.shopNo = shipment.shopNo;
						respCopy.isPrepaidOrder = shipment.isPrepaidOrder;
						respCopy.orderStatusId = shipment.orderStatusId;
						respCopy.orderId = shipment.orderId;
						resp.MasterOrderID = shipment.MasterOrderID;
						resp.Waybillnumber = shipment.Waybillnumber;
						ordersDetails.push(respCopy);
					}
				}),
			));
		this.setState({
			allOrderDetails: ordersDetails,
			showLoader: false,
		});
	};

	printShipmentList = () => {
		this.setState({ showPrintOrders: true }, () => {
			this.setState({ printingShipmentList: true });
			setTimeout(() => {
				this.setState({ printingShipmentList: false });
			}, 1500);
			_printElement("print-shipmentlist");
			this.setState({ showPrintOrders: false });
		});
	};

	render() {
		const isDepotDriver = this.state.isDriver && this.props.context.isDepot;
		return (
			<div className="printable-content" id="print-shipmentlist">
				<Fragment>
					<div className="package-list" tabIndex="0">
						<Modal
							closeModal={() => this.close()}
							width={!this.state.showPreview ? "500px" : "700px"}
							header={
								this.state.viewingList
									? "View shipment lists"
									: !this.state.showPreview
									? this.state.isEditing
										? "Update shipment list"
										: "Create shipment list"
									: ""
							}
							isHeaderClose={!this.state.showPreview ? false : true}
						>
							{this.state.showLoader ? (
								<Loading size={"4px"} margin={"120px auto"} />
							) : (
								<Fragment>
									<div
										style={{
											paddingBottom: this.state.showPreview ? "10px" : "60px",
										}}
									>
										{this.state.showPreview ? (
											<Fragment>
												{isDepotDriver && window.screen.width < 767 ? (
													this.renderPOSPrint()
												) : (
													<>
														{this.renderShipmentData()}
														{this.state.showPrintOrders
															? this.renderOrderData()
															: ""}
													</>
												)}
												<div className="modal-submit no-print">
													{this.state.isPackageManager &&
														!this.state.packageListStatus &&
														this.props.showMoveGoodsInTransit &&
														this.props.context.hasPermission(168, 3) && (
															<div
																style={{ marginRight: "15px" }}
																onMouseEnter={() =>
																	this.setState({
																		statusIconColor: "#fff",
																	})
																}
																onMouseLeave={() =>
																	this.setState({
																		statusIconColor: "#015fd1",
																	})
																}
															>
																<Button
																	type={"outline"}
																	onClick={() => this.getPackageListStatus()}
																	noMargin={true}
																	loading={this.state.gettingStatus}
																>
																	<SkuIcon
																		height={"13px"}
																		width={"13px"}
																		color={
																			this.state.statusIconColor || "#015fd1"
																		}
																	/>
																	Get Status
																</Button>
															</div>
														)}
													{this.props.showMoveGoodsInTransit &&
														this.props.context.hasPermission(168, 3) && (
															<div style={{ marginRight: "15px" }}>
																<div
																	onMouseEnter={() =>
																		this.setState({
																			altIconColor: "#fff",
																		})
																	}
																	onMouseLeave={() =>
																		this.setState({
																			altIconColor: "#015fd1",
																		})
																	}
																>
																	<Button
																		type={"outline"}
																		onClick={() => this.dispatchOrders()}
																		noMargin={true}
																		loading={this.state.movingInTransit}
																		disabled={
																			this.state.isPackageManager &&
																			!this.state.dispatchApproved
																		}
																	>
																		<LeadStageChangeIcon
																			height={"13px"}
																			width={"13px"}
																			color={this.state.altIconColor}
																		/>
																		Dispatch
																	</Button>
																</div>
															</div>
														)}
													{(isDepotDriver ||
														!this.state.isPackageManager ||
														this.state.dispatchApproved ||
														!this.props.showMoveGoodsInTransit) && (
														<div
															onMouseEnter={() =>
																this.setState({ printIconColor: "#fff" })
															}
															onMouseLeave={() =>
																this.setState({
																	printIconColor: "#015fd1",
																})
															}
														>
															<Button
																type={"outline"}
																onClick={() => this.printShipmentList()}
																noMargin={true}
																disabled={this.state.movingInTransit}
																loading={this.state.printingShipmentList}
															>
																<PrintIcon
																	height={"13px"}
																	width={"13px"}
																	color={this.state.printIconColor}
																/>
																Print
															</Button>
														</div>
													)}
												</div>
											</Fragment>
										) : (
											""
										)}
									</div>
								</Fragment>
							)}
						</Modal>
					</div>
				</Fragment>
			</div>
		);
	}

	renderOrderData = () => {
		return (
			<Fragment>
				{this.state.allOrderDetails.map((order, i) => {
					const isPayLaterOrder =
						order.OrderPaymentStatus &&
						order.OrderPaymentStatus.toLowerCase() === "paylater";
					const isPrepaidOrder =
						order.OrderPaymentStatus &&
						order.OrderPaymentStatus.toLowerCase() === "prepaid";
					const netPayable =
						order.TotalOrderValue -
						(Number(order.couponDiscount || 0) +
							Number(order.promoDiscount || 0) +
							Number(order.PaidFromWallet || 0) +
							Number(order.omniPointsDiscount || 0));

					const totalPayableAmount = netPayable + order.ConvenienceFee;
					return (
						<OrderPrintInvoice
							key={`order_invocie_${i}`}
							context={this.props.context}
							statesData={{
								orderDetailRetail: { ...order },
								alternatePhones: {
									alternatePhone1: order.alternatePhone1,
									alternatePhone2: order.alternatePhone2,
								},
							}}
							propsData={{
								orderDetails: {
									...this.props,
									OrganizationName: "",
									MasterOrderId: order.MasterOrderID,
									Orderid: order.orderId,
								},
							}}
							isPayLaterOrder={isPayLaterOrder}
							isPrepaidOrder={isPrepaidOrder}
							netPayable={netPayable}
							totalPayableAmount={totalPayableAmount}
						/>
					);
				})}
			</Fragment>
		);
	};

	renderShipmentData = () => {
		// const order = this.state.order;
		const isDepotManager = this.props.context.isDepot && !this.state.isDriver;
		return (
			<Fragment>
				<div className="package-list-header" ref={this.containerRef}>
					<div className="package-list-header-logo">
						{this.props.context.HeaderData.userProfileImg && (
							<img
								src={asset_url + this.props.context.HeaderData.userProfileImg}
								alt=""
							/>
						)}
					</div>
					<div className="package-list-header-name">
						{this.props.context.HeaderData.BusinessName}
						{this.state.shipmentOrderData.businessAddress}
					</div>
				</div>
				<div
					className={`package-list-table ${
						!isDepotManager ? "print-page-break" : " "
					}`}
				>
					<div className="package-list-table-header">Shipment list</div>
					<div className="package-list-table-row">
						<div className="package-list-table-row-column">
							{this.props.shipmentData && this.props.shipmentData.batchNumber && (
								<div className="package-list-data">
									<div className="package-list-label">Batch Number</div>
									<div className="package-list-value">
										{this.state.shipmentOrderData.batchNumber}
									</div>
								</div>
							)}
							<div className="package-list-data">
								<div className="package-list-label">No of sales orders</div>
								<div className="package-list-value">
									{this.state.shipmentOrderData.shipmentOrders &&
										this.state.shipmentOrderData.shipmentOrders.length}
								</div>
							</div>
							<div className="package-list-data">
								<div className="package-list-label">Total order value</div>
								<div className="package-list-value">
									{_formatCurrency(
										this.state.shipmentOrderData.totalOrderValue,
									)}
								</div>
							</div>
						</div>
						<div className="package-list-table-row-column">
							<div className="package-list-data">
								{(this.props.showShipmnetId ||
									(this.state.shipmentOrderData.wayBillNumber &&
										this.state.isPackageManager)) && (
									<>
										<div className="package-list-label">Shipment Number</div>
										<div className="package-list-value">
											{this.props.packageId}
										</div>
									</>
								)}
							</div>
							<div className="package-list-data">
								<div className="package-list-label">Shipment Date</div>
								<div className="package-list-value">
									{this.state.shipmentOrderData.packageCreatedDate
										? dayjs(
												this.state.shipmentOrderData.packageCreatedDate,
										  ).format("MMM D, YYYY")
										: this.state.shipmentOrderData.packageCreatedDate}
								</div>
							</div>
							<div className="package-list-data">
								<div className="package-list-label">Shipment Time</div>
								<div className="package-list-value">
									{this.state.shipmentOrderData.packageCreatedDate
										? dayjs(
												this.state.shipmentOrderData.packageCreatedDate,
										  ).format("h:mm a")
										: this.state.packageTime}
								</div>
							</div>
						</div>
					</div>
					<div className="package-list-table-row">
						<div className="package-list-table-row-column">
							<div className="package-list-data">
								<div className="package-list-label">Warehouse manager</div>
								<div className="package-list-value">
									{this.state.shipmentOrderData.storePersonName || ""}
								</div>
							</div>
							<div className="package-list-data">
								<div className="package-list-label">Tel</div>
								<div className="package-list-value">
									{this.state.shipmentOrderData.storePersonPhone || ""}
								</div>
							</div>
							<div className="package-list-data">
								<div className="package-list-label">Destination</div>
								<div className="package-list-value">
									{this.state.shipmentOrderData.stockpointname || ""}
								</div>
							</div>
							{this.state.shipmentOrderData.pickerName && (
								<div className="package-list-data">
									<div className="package-list-label">Picker name</div>
									<div className="package-list-value">
										{this.state.shipmentOrderData.pickerName}
									</div>
								</div>
							)}
						</div>
						<div className="package-list-table-row-column">
							<div className="package-list-data">
								<div className="package-list-label">Driver name</div>
								<div className="package-list-value">
									{this.state.shipmentOrderData.deliveryPersonName}
								</div>
							</div>
							<div className="package-list-data">
								<div className="package-list-label">Contact number</div>
								<div className="package-list-value">
									{this.state.shipmentOrderData.deliveryPersonPhone || ""}
								</div>
							</div>
							<div className="package-list-data">
								<div className="package-list-label">Vehicle number</div>
								<div className="package-list-value">
									{this.state.shipmentOrderData.vehicleNumber || ""}
								</div>
							</div>
							{this.props.shipmentData &&
								this.props.shipmentData.driverAssignedDate && (
									<div className="package-list-data">
										<div className="package-list-label">
											Driver Assigned Date
										</div>
										<div className="package-list-value">
											{dayjs(
												this.state.shipmentOrderData.driverAssignedDate,
											).format("MMM D, YYYY")}
										</div>
									</div>
								)}
						</div>
					</div>

					{this.state.IsGenerated && (
						<div
							className="package-list-table-row"
							style={{
								padding: "10px",
								color:
									this.state.IsGenerated.toLowerCase() === "generated" &&
									this.state.dispatchApproved
										? "#228B22"
										: this.state.IsGenerated.toLowerCase() ===
										  "shipment generation failed"
										? "#FF0000"
										: " #015fd1",
								backgroundColor:
									this.state.IsGenerated.toLowerCase() === "generated" &&
									this.state.dispatchApproved
										? "#228B2211"
										: this.state.IsGenerated.toLowerCase() ===
										  "shipment generation failed"
										? "#FF000011"
										: " #015fd111",
							}}
						>
							<p style={{ textAlign: "center", width: "100%" }}>
								{_capitalizeText(this.state.IsGenerated)}.{" "}
								{this.shipmentGenerationMessage || ""}
							</p>
						</div>
					)}

					<div className="package-list-table-row">
						{this.state.shipmentOrderData.soNumber && (
							<div className="package-list-table-row-column">
								<div className="package-list-data">
									<div className="package-list-label">SO Number</div>
									<div className="package-list-value">
										{this.state.shipmentOrderData.soNumber}
									</div>
								</div>
							</div>
						)}
						{this.state.shipmentOrderData.wayBillNumber && (
							<div className="package-list-table-row-column">
								<div className="package-list-data">
									<div className="package-list-label">Waybill Number</div>
									<div className="package-list-value">
										{this.state.shipmentOrderData.wayBillNumber}
									</div>
								</div>
							</div>
						)}
					</div>
					<div className="package-list-table-list">
						<div className="package-list-table-list-header">
							<div>S/N</div>
							<div>Sku code</div>
							<div>Item Description</div>
							<div>
								{this.props.context.HeaderData.walletAmount.WarehouseType === 1
									? "Price"
									: "UOM"}
							</div>
							<div>Quantity</div>
						</div>
						{this.state.shipmentOrderData.ItemDetails &&
							this.state.shipmentOrderData.ItemDetails.map((item, i) => {
								return (
									<div className="package-list-table-list-item" key={i}>
										<div>{i + 1}</div>
										<div>{item.skucode || "-"}</div>
										<div>{_capitalizeText(item.ItemName || "")}</div>
										<div>
											{this.props.context.HeaderData.walletAmount
												.WarehouseType !== 1
												? item.unit || "-"
												: _formatCurrency(item.Price)}
										</div>
										<div>{item.Quantity}</div>
									</div>
								);
							})}
					</div>
				</div>
				{isDepotManager && (
					<div className="print-page-break">
						<div className="package-list-signatures">
							<span>Prepared by</span>
							<span>Warehouse manager</span>
							<span>Driver's name and sign</span>
						</div>
					</div>
				)}
				{!isDepotManager && (
					<div className="print-page-break">
						<div className="heading-text">Delivery details</div>
						<div className="delivery-list-table-list">
							<div className="delivery-list-table-list-header">
								<div>Order Id</div>
								<div>Delivery to</div>
								<div>Phone number</div>
								{/* <div>SO number</div> */}
							</div>
							{this.state.shipmentOrderData.shipmentOrders &&
								this.state.shipmentOrderData.shipmentOrders.map((order, i) => (
									<div className="delivery-list-table-list-item" key={i}>
										<div>
											{this.props.context.isOmsAdminBusiness
												? order.orderId
												: `${order.MasterOrderID}-${order.orderId}`}
										</div>
										<div>{order.OrderLocation}</div>
										<div>{order.CustomerPhone}</div>
										{/* <div>{order.soNumber}</div> */}
									</div>
								))}
						</div>
						<div className="package-list-signatures">
							<span>Prepared by</span>
							<span>Warehouse manager</span>
							<span>Driver's name and sign</span>
						</div>
					</div>
				)}
			</Fragment>
		);
	};

	renderPOSPrint = () => {
		return (
			<Fragment>
				<table className="order--details">
					<tbody>
						<tr>
							<td class="table-heading" colspan="3">
								Mplify Ltd - Omnibiz Retail
							</td>
						</tr>
						<tr>
							<th>
								<div className="flex flex-between">
									<p style={{ flexGrow: 1 }}>Batch No</p>
									<p>:</p>
								</div>
							</th>
							<td>{this.state.shipmentOrderData.batchNumber}</td>
						</tr>
						<tr>
							<th>
								<div className="flex flex-between">
									<p style={{ flexGrow: 1 }}>Date</p>
									<p>:</p>
								</div>
							</th>
							<td>
								{this.state.shipmentOrderData.packageCreatedDate
									? dayjs(
											this.state.shipmentOrderData.packageCreatedDate,
									  ).format("DD/MM/YY")
									: this.state.shipmentOrderData.packageCreatedDate}
							</td>
						</tr>
						<tr>
							<th>
								<div className="flex flex-between">
									<p style={{ flexGrow: 1 }}>Time</p>
									<p>:</p>
								</div>
							</th>
							<td>
								{this.state.shipmentOrderData.packageCreatedDate
									? dayjs(
											this.state.shipmentOrderData.packageCreatedDate,
									  ).format("HH:MM")
									: this.state.packageTime}
							</td>
						</tr>
						<tr>
							<th>
								<div className="flex flex-between">
									<p style={{ flexGrow: 1 }}>Shipment No.</p>
									<p>:</p>
								</div>
							</th>
							<td>{this.props.packageId}</td>
						</tr>
					</tbody>
				</table>

				<table className="order--items">
					<tbody>
						<tr className="table-header">
							<th colspan="2">Item</th>
							<th>Qty</th>
							<th>Price</th>
						</tr>
						{this.state.shipmentOrderData.ItemDetails &&
							this.state.shipmentOrderData.ItemDetails.map((item, i) => {
								return (
									<tr className="table-data-row" key={i}>
										<td colspan="2">{_capitalizeText(item.ItemName || "")}</td>
										<td>{item.Quantity}</td>
										<td>{item.Price}</td>
									</tr>
								);
							})}
					</tbody>
				</table>
				<table className="order--price">
					<tbody>
						<tr>
							<th colspan="3"> Total</th>
							<td>
								{_formatCurrency(this.state.shipmentOrderData.totalOrderValue)}
							</td>
						</tr>
					</tbody>
				</table>
			</Fragment>
		);
	};

	printList = () => {
		this.setState({ maxHeight: "none" });
	};

	close = () => {
		this.props.close();
	};
}

export default withAppData(ShipmentPrintList);
